import * as actions from '../../redux/actions';

import CommonService from '../../../../services/commonService';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';
import { useTranslation } from 'react-i18next';

const ThemeElevenFooter = props => {
	const operator = CommonService.getLocal('op') || props.operator;
	const centropuertoData = sessionStorage.getItem("centropuertoOperatorData")
	const parsedData = JSON.parse(centropuertoData);
	const language = sessionStorage.getItem("selectedLanguage")
	const footerLinks = language === 'en'
		// Use English links if available
		? parsedData && parsedData.header_links_en && parsedData.header_links_en.footer || []
		: operator && operator.header_links && operator.header_links.footer || [];


	const { t } = useTranslation('common');
	console.log("footer language", footerLinks)
	const getColor = () => {
		return {
			color:
				(operator &&
					operator.color_codes &&
					operator.color_codes.links_color &&
					operator.color_codes.links_color) ||
				'#fff',
		};
	};

	console.log('operator---->', operator);

	//
	return (
		<div>
			<div
				className="themes-theme-eleven-footer mt10"
				style={{
					background:
						operator &&
						operator.color_codes &&
						operator.color_codes.footer_color &&
						operator.color_codes.footer_color,
					color: getColor().color,
				}}
			>
				<div className="logo-box">
					<a href="/">
						<img
							alt=""
							src={operator && operator.footer_logo ? operator.footer_logo : ''}
							style={{
								marginTop: '0',
								width: operator && operator.footer_logo_width && operator.footer_logo_width,
							}}
						/>
					</a>
				</div>
				<div className="new-container">
					<div className={'links-list '}>
						{/* {operator &&
							(operator && operator.header_links && operator.header_links.footer || []).map((val, index, arr) => { */}
						{footerLinks &&		// headerLinks.header_links &&
							(footerLinks || []).map((val, index, arr) => {

								return (
									<a
										key={index}
										style={{
											color: getColor().color,
										}}
										href={val.route}
									>
										{(index !== 0 || (index !== arr.length - 1 && index !== 0)) && (
											<span className="px-4">|</span>
										)}
										{val.label}
									</a>
								);
							})}
					</div>
					<div
						className={'contact-details mt-2'}
						style={{
							color: getColor().color,
						}}
					>
						<div className="contact-details-item">
							<img
								src={getIcons('TelephoneIconFooter', operator)}
								alt=""
								style={{ width: 20, marginRight: 5 }}
							/>
							<span>{t("CONTACT.TELEPHONE")} {operator && operator.phone_number}</span>
						</div>
						<span className="px-2">|</span>
						<div className="contact-details-item">
							<img
								src={getIcons('EmailIconFooter', operator)}
								alt=""
								style={{ width: 20, marginRight: 5 }}
							/>
							<span>{t("CONTACT.EMAIL")} {operator && operator.email}</span>
						</div>
					</div>
				</div>
			</div>
			{operator && operator.show_bottom_footer ? <ShowBottomFooter operator={operator} /> : null}
		</div>
	);
};

const ShowBottomFooter = ({ operator }) => {
	return (
		<div
			className="d-flex-c f-13 p-2"
			style={{
				background: operator && operator.color_codes ? operator.color_codes.sub_footer_color : '',
				color: operator && operator.color_codes ? operator.color_codes.primary_text_color : '',
			}}
		>
			<div>
				<span>{operator.operator_name === 'tacoha' ? 'Tacoha' : operator.name} 2023 </span>
				<span>
					{' '}
					- Todos los derechos reservados
					{/* © | <b>Mapa del sitio</b> | Powered by{' '} */}
				</span>
				{/* <a href="https://kupos.cl" target="_blank">
          <img
            src={getIcons('kuposLogo', operator)}
            // alt={this.props.t('TRANSLATIONS.VIATUR_LOGO')}
            className="footer-kupos-logo"
            alt=""
          />
        </a> */}
			</div>
		</div>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		themes: state.themes,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeElevenFooter);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeEleven/components/ThemeElevenFooter.js